import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TableConfig } from '@app/interfaces';

@Component({
  selector: 'app-data-grid',
  templateUrl: './data-grid.component.html',
  styleUrls: ['./data-grid.component.scss']
})
export class DataGridComponent implements OnInit {
  showPagination: boolean = false;
  defaultPageSize: number = 10;
  checkBoxesMode: any;
  selectedState: any = [];

  @Input() dataSource = <any>[];
  @Input() config = <TableConfig>{};
  @Input() dataLength: number = 0;
  @Input() isLoading: boolean = false;

  @Output() pageChangeEvent: any = new EventEmitter();
  @Output() dataActionEvent: any = new EventEmitter();
  @Output() selectedStates: any = new EventEmitter();

  onReorder: any;

  constructor() { 
    this.onReorder = this.onReorderHandler.bind(this)
  }

  emitPageEvent(event: any) {
    this.defaultPageSize = event.pageSize;
    this.pageChangeEvent.emit({
      limit: event.pageSize,
      offset: event.pageIndex === 0 ? 0 : event.pageSize * event.pageIndex,
    });
  }

  showDataField(d: any, key: string) {
    return d[key];
  }

  showImageField(d: any, key: string) {
    return d[key];
  }

  emitAction(data: any, button: any,) {
    this.dataActionEvent.emit({
      button: button,
      data: data
    });
  }

  ngOnInit(): void {
    this.showPagination = this.config.showPagination
      ? this.config.showPagination.showPageSizeSelector
      : false;
    this.defaultPageSize = this.config.showPagination
      ? this.config.showPagination.pageSize
      : this.config.paginationByApi
        ? this.config.paginationByApi.pageSize
        : this.defaultPageSize;
    this.checkBoxesMode = this.config.checkBoxesMode;

    console.log('config', this.config);
  }

  public onSelectionChanged = (e: any): void => {
    this.selectedStates.emit(e.selectedRowKeys);
  };

  public rowClickHandler = (e: any): void => {
    this.dataActionEvent.emit({
      eventName: "row-selected",
      data: e.data
    }); 
  }

  public onRowSaved(e: any) {
    this.dataActionEvent.emit({
      eventName: "row-edited",
      data: e.changes
    }); 
  }

  public onReorderHandler(e: any) {
    console.log(e)
    var visibleRows = e.component.getVisibleRows(),
    toIndex = this.dataSource.indexOf(visibleRows[e.toIndex].data),
    fromIndex = this.dataSource.indexOf(e.itemData);

    this.dataSource.splice(fromIndex, 1);
    this.dataSource.splice(toIndex, 0, e.itemData);

    this.dataActionEvent.emit({
      eventName: "re-order",
      data: this.dataSource
    }); 
  }

}
